/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {memoize} from "@/lib/memoize";

export class MusicTrackModel extends JsonModel<MusicTrackModel.IJson> {
  public get id(): number {
    return this.json.id;
  }

  public get name(): string {
    return this.json.name;
  }

  public get path(): string {
    return this.json.audioFile;
  }

  public get durationInSeconds(): number {
    return this.json.durationInMs / 1000;
  }

  public get segmentDurationInSeconds(): number {
    return this.json.segmentDurationInMs / 1000;
  }

  public get tags(): string[] {
    return this.json.tags;
  }

  public get thumbnail(): string {
    return this.json.thumbnail;
  }

  public get segments(): number[] {
    return this.json.segments;
  }

  @memoize
  public get segmentDurations(): number[] {
    if (this.segments.length === 0) return [];

    return this.segments.map((start, index) =>
      index < this.segments.length - 1 ? this.segments[index + 1] - start : this.durationInSeconds - start
    );
  }
}

export namespace MusicTrackModel {
  export interface IJson {
    audioFile: string;
    durationInMs: number;
    id: number;
    name: string;
    segmentDurationInMs: number;
    segments: number[];
    tags: string[];
    thumbnail: string;
  }
}
/* v8 ignore stop */
